import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { mobileAndTabletCSS } from '@measures/responsive'

const StyledLead = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: bodycopySmall2 },
        },
      },
      colors: { textDefault },
      utils: { ellipsis },
    },
  }) => css`
    ${bodycopySmall2};
    color: ${textDefault};
    ${ellipsis('100%', 3)}

    ${mobileAndTabletCSS(css`
      display: none;
    `)}
  `}
`

const Lead: FunctionComponent<{ children: string }> = ({ children: lead }) => (
  <StyledLead>{lead}</StyledLead>
)

export default Lead
